// charges-cycle.model.ts

export interface IChargesCycle {
  chargesCycleId: string;
  neighborhoodId: string;
  cutoffDay: number;
  maxPaymentDay: number;
  createdAt: string;
  updatedAt: string;
}

export class ChargesCycle implements IChargesCycle {
  chargesCycleId: string;
  neighborhoodId: string;
  cutoffDay: number;
  maxPaymentDay: number;
  createdAt: string;
  updatedAt: string;

  constructor(data: IChargesCycle) {
    this.chargesCycleId = data.chargesCycleId;
    this.neighborhoodId = data.neighborhoodId;
    this.cutoffDay = data.cutoffDay;
    this.maxPaymentDay = data.maxPaymentDay;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
}
